<div class="teamMemberManagement" *blockUI="'teamManagementUI'; template:blockTemplate;" >
  <div>
    <mat-form-field class="fullWidth">
      <mat-label>Email</mat-label>
      <textarea
        matInput
        cdkTextareaAutosize
        #autosize="cdkTextareaAutosize"
        cdkAutosizeMinRows="1"
        cdkAutosizeMaxRows="8"
        placeholder="Enter Email"
        required
        [(ngModel)]="emailList"
        #ctrl="ngModel"
        (keyup)="checkCanSave()"
      ></textarea>
      @if (ctrl.hasError('required') && ctrl.touched) {
        <mat-error>
          Please enter a coma separated list of emails.
        </mat-error>
      }
    </mat-form-field>
    @if(emailValidationMessage()){
      <div class="emailErrorMsg">
        <span>
          {{ emailValidationMessage() }}
        </span>
      </div>
    }
  </div>
  @if(memberGroups().length > 0){
    <div class="specialCheckbox">
      <mat-slide-toggle
        (change)="toggleFullAccess($event)"
        labelPosition="before"
        [(ngModel)]="fullAccess">Full Access
      </mat-slide-toggle>
    </div>
  }
</div>

<div [ngClass]="{ 'noShow': fullAccess, 'standardsAssignmentContainer': true }">
  <app-member-assignment-to-standards
    [fullAccess]="fullAccess"
    [groups]="memberGroups()"
    (groupsChange)="onGroupsChange($event)"
  ></app-member-assignment-to-standards>
</div>
<div>
  <div class="teamMemberManagementButtons">
    <app-weave-button
      [text]="'Add to Team'"
      (click)="saveMembersList()"
      [disabled]="!canSave()"
      [classes]="'formAction button '"
    ></app-weave-button>
    <app-weave-button
      [classes]="'secondary button cancelBtn'"
      [text]="'Cancel'"
      (click)="cancel()"
    ></app-weave-button>
  </div>
  @if (errorMessage()) {
    <div class="errorMessage">
      {{ errorMessage() }}
    </div>
  }
</div>
